import $ from 'jquery';
import InputMask from "inputmask";
import {updateInfoFromFileinput} from "../_lib/util/FileInputUtil";

let currentStep = 0;
const steps = document.querySelectorAll('.step');

function enableInputsOnLoad() {
    // Reabilita todos os inputs e selects desabilitados, exceto #categoriaId e #grauParentesco
    document.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input.disabled, select.disabled')
        .forEach(input => {
            if (input.id !== 'matriculaTitular' && input.id !== 'grauParentesco' && input.id !== 'moeda') {
                input.classList.remove('disabled');
                input.removeAttribute('disabled');
            }
        });

    // Reabilita botões
    document.querySelectorAll<HTMLButtonElement>('button[disabled]')
        .forEach(button => button.removeAttribute('disabled'));

    // Garante que #categoriaId e #grauParentesco permaneçam desabilitados
    const matriculaTitular = document.getElementById('matriculaTitular');
    const grauParentesco = document.getElementById('grauParentesco');

    if (matriculaTitular) {
        matriculaTitular.classList.add('disabled');
        matriculaTitular.setAttribute('disabled', 'true');
    }

    if (grauParentesco) {
        grauParentesco.classList.add('disabled');
        grauParentesco.setAttribute('disabled', 'true');
    }

    // Adiciona o evento de mudança no select #categoriaId
    document.querySelectorAll('#categoriaId')
        .forEach(el => el.addEventListener('change', onChangeCategoria));
}

document.addEventListener('DOMContentLoaded', () => {
    enableInputsOnLoad(); // Habilita os inputs e selects desabilitados ao carregar a página
    events(); // Reaplica os eventos do formulário
});


function updateProgressBar() {
    const progress = (currentStep + 1) / steps.length * 100;
    const progressBar = document.getElementById('progress-bar');
    progressBar.style.width = progress + '%';
    progressBar.textContent = `${currentStep + 1}/${steps.length}`;
}

function showStep(stepIndex) {
    // Limpar erros do step atual antes de sair
    steps[currentStep].querySelectorAll('.is-invalid').forEach(el => {
        el.classList.remove('is-invalid');
    });

    steps.forEach((step, index) => {
        step.style.display = index === stepIndex ? 'block' : 'none';
    });
    currentStep = stepIndex;
    updateProgressBar();
}

$(function () {
    initLeadSolicitacao();
    showDocumentacao();
    initWizard();
    infoLoad();
    masks();
    events();
})


function initWizard() {
    document.addEventListener('DOMContentLoaded', function() {
        showStep(0);
    });

    $(".prevStep").on("click", function(e) {
        if (currentStep > 0) {
            showStep(currentStep - 1);
        }
    });

    $(".nextStep").on("click", function(e) {
        const currentStepElement = steps[currentStep];
        const requiredInputs = currentStepElement.querySelectorAll('input[required], select[required]');
        let isValid = true;

        requiredInputs.forEach(input => {
            if (!validateInput(input)) {
                isValid = false;
                input.classList.add('is-invalid');

                // Mensagens de erro específicas
                let errorMessage = 'Este campo é obrigatório';
                if (input.id === 'telefone' && input.value) {
                    errorMessage = 'Telefone inválido. Use o formato (99) 99999-9999';
                } else if (input.id === 'cpf' && input.value) {
                    errorMessage = 'CPF inválido. Deve conter 11 dígitos';
                } else if (input.id === 'email' && input.value) {
                    errorMessage = 'Email inválido. Use o formato exemplo@dominio.com';
                }

                if (!input.nextElementSibling || !input.nextElementSibling.classList.contains('invalid-feedback')) {
                    const errorDiv = document.createElement('div');
                    errorDiv.className = 'invalid-feedback';
                    errorDiv.textContent = errorMessage;
                    input.parentNode.insertBefore(errorDiv, input.nextSibling);
                } else {
                    input.nextElementSibling.textContent = errorMessage;
                }
            } else {
                input.classList.remove('is-invalid');
                // Remove mensagem de erro se existir
                if (input.nextElementSibling && input.nextElementSibling.classList.contains('invalid-feedback')) {
                    input.nextElementSibling.remove();
                }
            }
        });

        if (isValid && currentStep < steps.length - 1) {
            showStep(currentStep + 1);
        }
    });
}

function infoLoad() {
    const badge = document.querySelector('.badge[data-bs-toggle="modal"]');
    const myModal = new bootstrap.Modal(document.getElementById('exampleModal'));

    badge.addEventListener('mouseover', function () {
        myModal.show();
    });

    badge.addEventListener('mouseleave', function (){
        myModal.hide();
    });
}

function showDocumentacao() {
    $("#categoriaId").on("change", function() {
        var categoriaId = $(this).val();

        const url = "/espaco-digital/habilitacao/categorias/" + categoriaId;

        var settings = {
            "url": url,
            "method": "GET"
        };

        $.ajax(settings).done(function (response) {
            var valorFormatado = response.valorRenovacao.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

            var content = `
            <div class="alert alert-sesc-blue rounded shadow-sm" style="overflow-y: auto; max-height: 300px;">
                <p class="mb-0"><b>Categoria:</b> <span>${response.nome}</span></p>
                <div class="mb-0">
                    <p class="mb-0 font-weight-bold"><b>Quem são:</b></p>
                    <div>${response.textoCondicao}</div>
                </div>
                <p class="mb-0">
                    <b>Taxa:</b> <span>${valorFormatado}</span>
                </p>
                <p class="mb-0 font-weight-bold"><b>Documentação:</b></p>
                <div>${response.textoDocumentacao}</div>
            </div>`;

            $("#preview-documentacao").html(content);
        });
    });
}

function CaptureFields() {
    var nome_completo = $("#nome").val();
    var email = $("#email").val();
    var cpf = $("#cpf").val();
    var data_nascimento = $("#dataNascimento").val();
    var telefone = $("#telefone").val();

    if (nome_completo && email && telefone) {
        const url = "/espaco-digital/habilitacao/captar/solicitacao";
        const body = {
            nome: nome_completo,
            email: email,
            cpf: cpf,
            dataNascimento: data_nascimento,
            telefone: telefone
        };

        // Pegar o token CSRF
        var csrfToken = $('meta[name="_csrf"]').attr('content');
        var csrfHeader = $('meta[name="_csrf_header"]').attr('content');

        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json', // Para enviar dados como JSON
            data: JSON.stringify(body),
            beforeSend: function(xhr) {
                // Adicionar o token CSRF ao cabeçalho da requisição
                xhr.setRequestHeader(csrfHeader, csrfToken);
            },
            success: function (response) {
                console.log('success', response);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(jqXHR, textStatus, errorThrown);
            }
        });
    }
}
function initLeadSolicitacao() {
    window.addEventListener('beforeunload', (event) => {
        CaptureFields();
    });
}

function masks() {
    function filterMask<T extends Element>(arr: string[]) {
        return arr.map(a => document.querySelector<T>(a)).filter(a => a !== null);
    }

    filterMask<HTMLInputElement>(['#cpf'])
        .forEach(el => (new InputMask({
            mask: '99999999999',
            clearIncomplete: true,
            placeholder: ''
        })).mask(el));

    filterMask<HTMLInputElement>(['#telefone'])
        .forEach(el => (new InputMask({
            mask: ['(99) 9999-9999', '(99) 99999-9999'],
            clearIncomplete: true,
            placeholder: ''
        })).mask(el));

    filterMask<HTMLInputElement>(['#matricula', '#matriculaTitular'])
        .forEach(el => (new InputMask({
            mask: ['9999-999999-9'],
            // clearIncomplete: true,
            placeholder: ''
        })).mask(el));
}

function events() {
    document.querySelectorAll<HTMLDivElement>('.container')
        .forEach(el => {
            el.querySelectorAll<HTMLFormElement>('.form-loading')
                .forEach(form => {
                    form.addEventListener('submit', (event) => {
                        // Validação antes do submit
                        let isValid = true;

                        // Validar todos os steps
                        steps.forEach(step => {
                            const inputs = step.querySelectorAll('input, select');

                            inputs.forEach(input => {
                                if (!validateInput(input)) {
                                    isValid = false;
                                    input.classList.add('is-invalid');

                                    // Mostrar mensagem de erro
                                    let errorMessage = 'Este campo é obrigatório';
                                    if (input.id === 'telefone' && input.value) {
                                        errorMessage = 'Telefone inválido';
                                    } else if (input.id === 'cpf' && input.value) {
                                        errorMessage = 'CPF inválido';
                                    } else if (input.id === 'email' && input.value) {
                                        errorMessage = 'Email inválido';
                                    }

                                    if (!input.nextElementSibling || !input.nextElementSibling.classList.contains('invalid-feedback')) {
                                        const errorDiv = document.createElement('div');
                                        errorDiv.className = 'invalid-feedback';
                                        errorDiv.textContent = errorMessage;
                                        input.parentNode.insertBefore(errorDiv, input.nextSibling);
                                    }
                                }
                            });
                        });

                        if (!isValid) {
                            event.preventDefault();
                            // Mostrar alerta e ir para o primeiro step com erro
                            alert('Por favor, preencha todos os campos obrigatórios corretamente antes de enviar.');
                            showStep(0);
                            return;
                        }

                        // Aplica o estado de loading se tudo for válido
                        form.querySelectorAll<HTMLInputElement | HTMLSelectElement>('input,select')
                            .forEach(input => input.classList.add('disabled'));

                        form.querySelectorAll<HTMLButtonElement>('button[type="submit"]')
                            .forEach(button => {
                                button.setAttribute('disabled', 'disabled');
                                button.innerHTML = '<i class="fa fa-spinner fa-pulse"></i> Verificando';
                            });
                    });
                });
        });

    document.querySelectorAll('#categoriaId')
        .forEach(el => el.addEventListener('change', onChangeCategoria));

    document.querySelectorAll('#servidor')
        .forEach(el => el.addEventListener('change', onChangeServidor));

    document.querySelectorAll('#documentos')
        .forEach(el => el.addEventListener('change', updateInfoFromFileinput));
}

const onChangeServidor: (this: HTMLInputElement, event: Event) => any = function () {
    toogleInputVisibility("#moeda", this.checked, this.checked ? null : 'PAGSEGURO');
}

const onChangeCategoria: (this: HTMLSelectElement, event: Event) => any = function () {
    const value = this.value;
    const {innerHTML: label, dataset: {dependente}} = this.options[this.selectedIndex];
    const inputsDisable = ['#matriculaTitular','#grauParentesco']
    let documentacao = document.querySelectorAll('.div-documentacao');
    if (documentacao) {
        documentacao.forEach(el => el.classList.add("d-none"));
        if (value.length > 0) {
            document.querySelectorAll(`.div-documentacao[data-id="cat-${value}"]`)
                .forEach(el => el.classList.remove('d-none'));
            for(var input of inputsDisable){
                toogleInputVisibility(input, label.includes('DEPENDENTE') || label.includes('DEP'));
            }
        }
    }
}

function toogleInputVisibility(selector, show, defaultValue = '') {
    const input = document.querySelector(selector);
    if (input) {
        if (show) {
            input.classList.remove('disabled');
            input.removeAttribute('disabled'); // Permite edição
            input.setAttribute('required', 'true'); // Exige valor
        } else {
            input.classList.add('disabled');
            input.setAttribute('disabled', 'true'); // Impede edição
            input.removeAttribute('required');
            if (defaultValue !== null) input.value = defaultValue; // Limpa valor quando necessário
        }
    }
    return input;
}

function validateInput(input: HTMLInputElement | HTMLSelectElement): boolean {
    if (input.hasAttribute('required') && !input.value.trim()) {
        return false;
    }

    // Validação específica para telefone
    if (input.id === 'telefone') {
        const phoneRegex = /^\(\d{2}\) \d{4,5}-\d{4}$/;
        if (!phoneRegex.test(input.value)) {
            return false;
        }
    }

    // Validação específica para CPF
    if (input.id === 'cpf') {
        if (input.value.replace(/\D/g, '').length !== 11) { // Remove não-dígitos antes de verificar
            return false;
        }
    }

    // Validação para email
    if (input.id === 'email') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(input.value)) {
            return false;
        }
    }

    return true;
}
